module.exports = __webpack_public_path__ + "img/4.066c4dba.webp";